/*
  Split test `pdp-sticky-atc-always`, variant-a: the sticky add-to-cart bar
  stays up from page load, over the main button too, and only steps aside over
  the footer.

  global.js decides visibility in ProductElement.onScroll and passes the answer
  to toggleStickyATC through `this`. Wrapping that method on the prototype
  changes the answer without touching global.min.js, and covers the new
  product-component a sibling colour swap creates, which a per-instance wrap
  would miss. The body class comes from the split embed and can land after this
  file, so it is checked on every call.
*/
(function () {
  'use strict';

  var CLASS_NAME = 'wb-sticky-atc-always';

  function active() {
    return document.body.classList.contains(CLASS_NAME);
  }

  function overFooter(pdp) {
    var footerHeight = pdp.footer ? pdp.footer.offsetHeight : 0;
    return window.innerHeight + window.scrollY >= document.body.offsetHeight - footerHeight;
  }

  function wrapPrototype() {
    var Ctor = window.customElements && customElements.get('product-component');
    if (!Ctor || typeof Ctor.prototype.toggleStickyATC !== 'function') return false;
    if (Ctor.prototype._wbStickyAlwaysWrapped) return true;

    var original = Ctor.prototype.toggleStickyATC;
    Ctor.prototype.toggleStickyATC = function (shouldShow) {
      if (active()) shouldShow = !overFooter(this);
      return original.call(this, shouldShow);
    };
    Ctor.prototype._wbStickyAlwaysWrapped = true;
    return true;
  }

  // After a sibling swap the stale outer element is still in the DOM, so pick the one whose bar is attached
  function currentPdp() {
    var all = document.querySelectorAll('product-component');
    for (var i = all.length - 1; i >= 0; i -= 1) {
      if (all[i].fixedAtc && all[i].fixedAtc.isConnected) return all[i];
    }
    return null;
  }

  function apply() {
    if (!active() || !wrapPrototype()) return;
    var pdp = currentPdp();
    if (pdp) pdp.toggleStickyATC(true);
  }

  function start() {
    apply();
    // The embed adds the class once it has the assignment, which on a first visit is after load
    new MutationObserver(apply).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    // A sibling swap mounts a new product element; show its bar without waiting for a scroll
    document.body.addEventListener('recommendations:reload', function () {
      window.setTimeout(apply, 0);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
